import { adminHttpClient } from '../../../../commons/adminHttpClient'

type FinalizePerksBenefitDesignRequest = {
  planPeriodId: string
}

const finalizeQsehraBenefitDesign = (request: FinalizePerksBenefitDesignRequest): Promise<any> => {
  return adminHttpClient.put('/AdminDashboard/Qsehra/BenefitDesign/FinalizeBenefitDesign', request)
}

export default finalizeQsehraBenefitDesign
